var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charDetails"},[(this.character !== null)?_c('h4',{domProps:{"textContent":_vm._s(_vm.character.name)}}):_vm._e(),_c('ComboContainer',{attrs:{"current-tab":this.currentTab,"character":this.character}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }